import { useTranslation } from 'react-i18next';
import { Badge, Button, Input } from '@/shared/ui';

export interface TravelStripProps {
  travel: number;
  travelAuto: boolean;
  onChange: (raw: string) => void;
  onReset: () => void;
}

/**
 * Proužek přejezdu mezi dvěma zastávkami. Vlevo vodící lišta (přerušovaná svislá linka spojující
 * pořadová čísla zastávek — zarovnání kopíruje rozvržení {@link StopRow}: grip + číselné kolečko),
 * vpravo pole s časem přejezdu (jednotka uvnitř pole) a indikátor auto / tlačítko „↺ mapa".
 */
export function TravelStrip({ travel, travelAuto, onChange, onReset }: TravelStripProps) {
  const { t } = useTranslation('products');
  return (
    <div className="px-phx-3 gap-phx-3 flex items-stretch">
      {/* Vodící lišta — kopíruje šířku grip + kolečka v StopRow, takže linka vede středem koleček. */}
      <span aria-hidden className="invisible leading-none select-none">
        ⠿
      </span>
      <div className="flex w-6 justify-center" aria-hidden>
        <span className="border-phx-border-2 border-l border-dashed" />
      </div>

      <div className="py-phx-1 gap-phx-2 flex items-center">
        <span className="text-phx-text-muted text-[10px] font-medium tracking-wide uppercase">
          {t('stationChain.stops.travelShort')}
        </span>
        <Input
          type="number"
          size="xs"
          min={0}
          value={travel}
          unit={t('stationChain.stops.min')}
          onChange={(event) => onChange(event.target.value)}
          className="w-20"
        />
        {travelAuto ? (
          <Badge tone="neutral">{t('stationChain.stops.auto')}</Badge>
        ) : (
          <Button type="button" variant="ghost" size="sm" iconLeft="refresh" onClick={onReset}>
            {t('stationChain.stops.resetTravel')}
          </Button>
        )}
      </div>
    </div>
  );
}
